<template>
	<div class="regenerate" :class="{mobileRenegate:isMobile}">
		<i class="btn regenerate" :class="{ disabled: disabledPre || currentOnClickedStatus }" @click="preFn">
			<CoolJiantouzuo size="16" />
		</i>
		<span class="indicator" :class="{ disabled: currentOnClickedStatus }">{{ cur + 1 }}/{{ total }}</span>
		<i class="btn regenerate" :class="{ disabled: disabledNext || currentOnClickedStatus }" @click="nextFn">
			<CoolJiantouyou size="16" />
		</i>
	</div>
</template>

<script setup lang="ts">
import { computed, ref, getCurrentInstance} from 'vue';
import { useChatStore } from '/@/stores/chat';
import { setScrollPosition } from '/@common/utils/other';
import { useRoute } from 'vue-router';
import { cloneDeep } from 'lodash-es'
import {
	updateIsSelect
} from '/@/api/chat';
import { useBasicLayout } from '/@common/hooks/useBasicLayout';
const { isMobile } = useBasicLayout();
const chatStore = useChatStore();
const route = useRoute();
const currentOnClickedStatus = computed(() => route.path.indexOf('share') >= 0);
const dataList = computed(() => chatStore.chatList);
interface Props {
	oldregens?: [];
}
const props = defineProps<Props>();
const lastItem = computed(() => {
	const item = dataList.value[dataList.value?.length - 1];

	return item;
});
const cur = computed({
	get: () => lastItem.value.curIndex,
	set: (val) => {
		const item = dataList.value[dataList.value?.length - 1];
		item.curIndex = val;
	},
});

const total = computed(() => lastItem.value?.regens?.length);

const disabledPre = computed(() => cur.value === 0);
const disabledNext = computed(() => cur.value === lastItem.value?.regens?.length - 1);

const preFn = () => {
	// console.log('preFn');
	if (currentOnClickedStatus.value) return;
	if (cur.value === 0) return;
	cur.value--;
	lastItem.value.curIndex = cur.value;
	updateLastItem();
};

const nextFn = () => {
	// console.log('nextFn');
	if (currentOnClickedStatus.value) return;
	if (cur.value >= total.value - 1) return;
	cur.value++;
	lastItem.value.curIndex = cur.value;
	updateLastItem();
};

const updateLastItem = async () => {
	const lastObj = cloneDeep(lastItem.value);

	const regens = cloneDeep(lastObj.regens);

	regens.forEach((anwser) => {
		if (anwser.id === lastObj.id) {
			// 需要更新选中状态到 regens 数据中
			anwser.is_up = lastObj.is_up;
			anwser.is_down = lastObj.is_down;
			anwser.feedBackStatus = lastObj.feedBackStatus
		}
	});
	
	// 当前选中的答案
	const switchItem = regens[cur.value];
	// 需要把重新生成的 prompt 改成最初那条数据的 prompt

	if (switchItem.id) {
		await updateIsSelect(switchItem.id)
	}
	// switchItem.question = lastObj.question;
	switchItem.regen = true;
	switchItem.isEdit=false
	switchItem.forbidden = false;
	// 设置选中答案到最后一条数据
	chatStore.setLastItem({ ...switchItem, curIndex: cur.value, regens,oldregens:props.oldregens })
	setScrollPosition('.center-side');
};
</script>

<style lang="scss" scoped>
.regenerate {
	display: flex;
	align-items: center;
	gap: 8px;
}
.mobileRenegate{
	gap: 0px;
}

.btn {
	width: 20px;
	height: 20px;
	cursor: pointer;
	color: #999;
	font-size: 16px;
	text-align: center;
	line-height: 20px;
	border: 1px solid transparent;
	border-radius: 4px;

	&:hover {
		background-color: var(--hover_icon_grey_1, rgba(79, 88, 102, 0.06));
	}
}

.indicator {
	color: var(--txt_icon_black_1);
	font-family: 'PingFang SC';
	font-size: 12px;
	font-style: normal;
	font-weight: 600;
	line-height: 20px; /* 166.667% */
	display: inline-block;
}

.disabled {
	opacity: 0.3;

	&:hover {
		background: transparent;
	}
}
</style>
